import React from 'react';
import { layers } from '@jira/platform__ui-layers';
import Blanket from '@atlaskit/blanket';
import Portal from '@atlaskit/portal';
import UFOLoadHold from '@atlaskit/react-ufo/load-hold';
import { useLoomRecorderLoadingBlanket } from '../../controllers/use-loom-recorder-loading-blanket/index.tsx';

/**
 * This blanket component is meant to be used in conjunction with the useJiraLoomCrossFlow hook.
 * It will render a blanket whenever a cross-flow journey is in progress or when we are trying to bring
 * up the record SDK after cross-flow finishes.
 */
export const LoomRecorderLoadingBlanket = () => {
	const [{ isBlanketShown, isPolling }] = useLoomRecorderLoadingBlanket();

	// the blanket has to be on top of everything. If we use layers.blanket, it will be behind issue view modals.
	return (
		isBlanketShown && (
			<>
				<Portal zIndex={layers.spotlight + 1}>
					<Blanket isTinted />
				</Portal>
				<UFOLoadHold name="loom-recorder-loading-blanket" hold={isPolling} />
			</>
		)
	);
};
